import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCarrot, faEye, faPenToSquare, faQuestion } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { useGetUserQuestionsQuery } from '../userQuestionApiSlice'
import { memo } from 'react'
import useAuth from "../../../hooks/useAuth"
import getFilePath from '../../../utils/getFilePath'


const UserQuestionAdmin = ({ userQuestion }) => {
    const {groupId} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()





    const navigate = useNavigate()
  

    if (userQuestion) {
        //const created = new Date(userQuestion.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })
         const cellStatus =''

         
   
  
        return (
            <tr className="table__row">
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{userQuestion.finalQuestionSet?.title}</td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{userQuestion.username}</td>

                <td className={`table__cell userQuestion__title ${cellStatus}`}>
                <span className="d-flex">
                    {userQuestion.fullname}
                {userQuestion.userImage && <div className='profile-image' style={{backgroundImage:`url(${getFilePath(userQuestion.userImage)})`}}></div>}
</span>
                </td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{ new Date( userQuestion.finalQuestionSet?.fromDate).toLocaleString()}  </td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{new Date(userQuestion.finalQuestionSet?.toDate).toLocaleString()}  </td>
                <td className={`table__cell userQuestion__actions ${cellStatus}`} >{userQuestion.totalScore}</td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>
                  
                </td>
            </tr>
        )

    } else return null
}

const memoizedUserQuestionAdmin = memo(UserQuestionAdmin)

export default memoizedUserQuestionAdmin